import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import { isEmpty } from 'utils/validations'
import * as parameterActions from 'action/systemParameters'
import ContentHeader from 'component/utils/ContentHeader'
import NewTableSystemParameters from './newTableSystemParameters'
import NewPagination from 'component/pagination/newPagination'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import SizeSelect, {components} from 'react-select'
import { colourStyles } from 'utils/selectStyle'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import FiltersForm from './FiltersForm'
import ViewModal from './ViewModal'
import EditModal from './EditModal'
import SuccessModal from 'component/Modal/SuccessModal'
import './styles.css'

class SystemParametersContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    parameters: PropTypes.array.isRequired,
    fetchParameters: PropTypes.func.isRequired,
    getParameter: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    filter: PropTypes.object,
    updateFilter: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    parameter: PropTypes.object,
    error: PropTypes.object,
    resetEditParameter: PropTypes.func,
  }

  state = {
    modal: false,
    disabled: true,
    optionSize: 10,
    page: 0,
    pagination: { page: 0, size: 10 },
    order: 'nuParameter',
    orderDirection: "ASC",
    searchFilter: {
      dsParameter: '',
      dsValue: '',
      dsKey: '',
    },
    branchs:[],
    idBranchs:[],
    selectedOptions: [],
    filterApplied: false,
    inputText: '',
    selectedParameter: null,
    isEditModal:false,
    successModalMsg: ""
  }
  
  componentDidMount() {
    this.handleFetchParameters()
  }

  handleFetchParameters = (page) => {
    const {
      fetchParameters,
      auth: { user },
    } = this.props;
  
    const { optionSize, pagination, searchFilter, order, orderDirection, idBranchs } = this.state;
  
    const adjustedPage = page !== undefined ? page + 1 : pagination.page + 1;
  
     // Checks if array has 57 or more items, if yes set [0] to indicate "All"
    const selectedBranch = idBranchs.length >= 57 ? [0] : idBranchs;

    const filterParams = {
      ...this.props.filter,
      ...searchFilter,
      size: optionSize,
      order, 
      orderDirection,
      idBranchs: selectedBranch
    };

    fetchParameters(user.dsToken, filterParams, adjustedPage);
  };

  handleSortChange = (newOrder, newDirection) => {
    this.setState(
      {
        order: newOrder,
        orderDirection: newDirection,
      },
      () => {
        this.handleFetchParameters(this.state.pagination.page); 
      }
    );
  };
  
  handleBranchChange =(event)=>{
    let branchs = []
    for (const b of event.target.value) {
      if (b.idBranches) {
        branchs.push(...b.idBranches)
      } else {
        branchs.push(b.value)
      }
    }
    branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)
 
    this.setState(
      { branchs: event.target.value, idBranchs: branchs },
      () => {
        this.handleFetchParameters(0);
      }
    );
  }

  handleParameterSearchChange = (selectedOptions) => {
    const filterMap = {
      descricao: 'dsParameter',
      parametro: 'dsKey',
      valor: 'dsValue',
    };
  
    const newSearchFilter = {
      dsParameter: '',
      dsValue: '',
      dsKey: '',
    };
  
    if (selectedOptions.length === 0) {
      // If there are no options, fill in all fields with the value entered
      newSearchFilter.dsParameter = this.state.inputText;
      newSearchFilter.dsValue = this.state.inputText;
      newSearchFilter.dsKey = this.state.inputText;
      
    } else {
      // If options are selected, fill in only the corresponding field
      selectedOptions.forEach(option => {
        const filterKey = filterMap[option.value];
        if (filterKey) {
          newSearchFilter[filterKey] = this.state.inputText;
        }
      });
    }
  
    this.setState(
      { searchFilter: newSearchFilter, selectedOptions },
      () => {
        this.handleFetchParameters();
      }
    );
  };
  
  handleSearchChange = (value) => {
    if (value.trim() === '') {
      this.setState(
        {
          inputText: '',
          searchFilter:{
            dsParameter:"",
            dsValue:"",
            dsKey:""
          }
        },
        ()=>{
          this.handleFetchParameters()
        }
      );
      return;
    }
  
    const { selectedOptions } = this.state; 

    // If no option is selected, fill in all fields
    if (selectedOptions.length === 0) {
      this.setState({
        searchFilter: {
          dsParameter: value,
          dsValue: value,
          dsKey: value,
        },
      });
    } else {
      // If you have options selected, just fill in the corresponding field
      const filterMap = {
        descricao: 'dsParameter',
        parametro: 'dsKey',
        valor: 'dsValue',
      };
  
      const newSearchFilter = { ...this.state.searchFilter };
  
      selectedOptions.forEach(option => {
        const filterKey = filterMap[option.value];
        if (filterKey) {
          newSearchFilter[filterKey] = value;
        }
      });
  
      this.setState({
        searchFilter: newSearchFilter,
      });
    }
    this.setState({ inputText: value });
  };

  handleTextChange =(value)=>{
    this.setState({inputText: value})
  }

  handleFilterSubmit = () => {
    this.setState(
      {
        pagination: { ...this.state.pagination, page: 0 }, 
      },
      () => {
        this.handleFetchParameters(); 
      }
    );
  };
  
  handleSubmit = (values) => {
    const {
      auth: { user },
      update,
    } = this.props

    update(user.dsToken, values, this.onSubmitSuccess)
  }

  onSubmitSuccess = () => {
    this.closeModal()
    this.setState({  successModalMsg: "O parâmetro foi salvo com sucesso!", });
    this.handleFetchParameters()
  }

  renderEmptyNotification = () => {
    const { translate } = this.props

    return (
      <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
        <p>{translate('system.parameters.noFilter')}</p>
      </div> 
    )
  }    

  openModal = (parameter) => {
    this.setState({ modal: true, selectedParameter: parameter, isEditModal: false, });

  }

  closeModal = () => {
    this.setState({ modal: false, selectedParameter: null });
  };

  toggleView = () => {
    const { modal } = this.state;
    this.setState({ modal: !modal });
  };

  openEditModal = (parameter) => {
    this.setState({ isEditModal: true, modal: false, selectedParameter: parameter });
  };

  closeEditModal = () => {
    this.setState({ isEditModal: false });
  };

  toggleEdit = (isOpen, parameter = null) => {
    this.setState({ isEditModal: isOpen, selectedParameter: parameter });
  };

  handleEditModal = (parameter) => {
    this.setState({
      isEditModal: true,
      selectedParameter: parameter,
    });
  };

  setOptionSize = (size) => {
    this.setState({ optionSize: size }, () => {
      this.setPagination({ page: 0, size });
    });
  }

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => {

    this.handleFetchParameters(this.state.pagination.page); 
  });
  }
  
  renderNewPagination = () => {
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

    const { translate, parameters, count } = this.props;
    const { optionSize, pagination } = this.state;

    const countItems = () => {

      const { pagination } = this.state;

      const startItem = pagination.page * pagination.size + 1;
      const endItem = Math.min((pagination.page + 1) * pagination.size, count);
      return `${startItem} - ${endItem}`;
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if (!parameters || parameters.length === 0) return

    return (
    <Row className="new-relatory-row stock-transfer-pagination" >
        <Col className="align-center" >

        <NewPagination
        navClass='pagination new-relatory'
        count={count}
        current={pagination.page + 1}
        getPage={(newPage) => {
          this.setPagination({ page: newPage - 1, size: optionSize });
        }}
        pages={Math.ceil(count / optionSize)}
      />

      <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
              <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
              <Col xs={4}>
                <SizeSelect
                components={{DropdownIndicator}}
                  isSearchable={false}
                  styles={colourStyles}
                  classNamePrefix='react-select'
                  onChange={(option) => {
                    this.setOptionSize(option.value)
                    this.setPagination({...this.state.pagination, page: 0, size: option.value })

                  }}
                  options={PAGINATION_OPTIONS}
                  value={PAGINATION_OPTIONS.find((i) => i.value === this.state.optionSize)}
                  menuPlacement='top'
                />
              </Col>
        </div>


        <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
              <Col >{`
              ${translate('pagination.size.show')}
              ${countItems() }
              ${translate("pagination.size.of")}
              ${count}
              ${translate("pagination.size.items")}`}</Col>

        </div>

      </Col>


    </Row>
    )
  }

  render() {
    const { translate, parameters, auth } = this.props
    const { modal, selectedParameter, isEditModal, successModalMsg } = this.state;

    return (
      <div className='system-parameters-container'>
        <ContentHeader>{translate('systemParameters.title')}</ContentHeader>

        <div className='padding-bottom header-mission-block'>
        
          <FiltersForm
            user={auth.user}
            submit={this.handleFilterSubmit} 
            searchFilter={this.state.searchFilter} 
            onChange={this.handleSearchChange} 
            translate={translate}
            branchs={this.state.branchs}
            handleBranchChange={this.handleBranchChange}
            handleParameterSearchChange={this.handleParameterSearchChange}
            handleTextChange={this.handleTextChange}
          />

        </div>

        <div className='stock-adjustment-table new'>

          <div style={{boxShadow: 'none'}} className='outer-table stock-transfer-outer-table'>
          {isEmpty(parameters) ? (
            this.renderEmptyNotification()
          ) : (
            <>
              <NewTableSystemParameters
                parameters={parameters}
                translate={translate}
                openModal={this.openModal}
                handleOrder={this.handleSortChange}
                handleEditModal={this.handleEditModal}
              />
              { modal && (
                <ViewModal
                isOpen={modal}
                onClose={this.closeModal}
                parameter={selectedParameter}
                translate={translate}
                toggleView={this.toggleView}
                toggleEdit={this.toggleEdit} 
                />
                )
              }
              
              { isEditModal && (
                <EditModal
                isOpen={isEditModal}
                onClose={this.closeEditModal}
                parameter={selectedParameter}
                translate={translate}
                toggleView={this.toggleView}
                toggleEdit={this.toggleEdit}
                onSubmit={this.handleSubmit}
                />
                )
              }
            </>
          )}

          {this.renderNewPagination()}
          {successModalMsg && (
            <SuccessModal
              center
              t={translate}
              msg={successModalMsg}
              size='sm'
              handleClose={() => {
                this.setState({ successModalMsg: false })
                this.handleFetchParameters()
              }}
              fillButton
              buttonText='Concluir'
            />
            )}
          </div>
        </div>
      </div>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ systemParametersReducer, paginateReducer }) => ({
  parameters: systemParametersReducer.list.records,
  filter: systemParametersReducer.list.filter,
  parameter: systemParametersReducer.get.record,
  error: systemParametersReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...parameterActions }, dispatch)

const ParameterListTranslated = translate(null, { wait: true })(
  SystemParametersContainer
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParameterListTranslated)

export { SystemParametersContainer as SystemParameters }
